<template>
  <div class="drone-header" @mouseenter="handleMouseenter" @mouseleave="handleMouseleave">
    <div class="drone-header-content">
      <div class="right">
        <el-tooltip effect="dark" :content="'收起/展开'">
          <em
            class="icon"
            :class="isUnfold ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
            @click="boxViewToggle"
          ></em>
        </el-tooltip>

        <el-tooltip
          effect="dark"
          :content="(theme === 'dark' ? '黑夜主题' : '白天主题') | translateTo(i18nPath)"
        >
          <em class="icon iconfont" :class="`icon-${theme}`" @click="changeTheme"></em>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          :content="(fullScreen ? '退出全屏' : '进入全屏') | translateTo(i18nPath)"
        >
          <em
            class="icon iconfont"
            :class="fullScreen ? 'icon-quitquanping' : 'icon-quanping'"
            @click="screenToggle"
          ></em>
        </el-tooltip>
        <el-tooltip effect="dark" :content="'设置' | translateTo(i18nPath)">
          <em class="icon el-icon-setting" @click="openSettingsPanel"></em>
        </el-tooltip>
      </div>
    </div>
    <el-drawer
      :title="$t('settings')"
      :size="inLangs('zh') ? '500px' : '600px'"
      :modal="false"
      :append-to-body="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :withHeader="true"
      :visible.sync="drawerVisible"
    >
      <MForm
        :config="formConfig"
        :i18nPath="i18nPath"
        :model="monitorConfig"
        :dataSource="dataSource"
      />
    </el-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Type from '@/store/mutation-type';
import screenfull from 'screenfull';

import MForm from '@/components/form/index.vue';

export default {
  components: { MForm },
  inject: ['getDroneCtx', 'getDroneEl'],
  props: {
    isUnfold: Boolean
  },
  data() {
    return {
      isFullScreen: true,
      i18nPath: 'part',
      visible: false,
      fullScreen: false,
      popoverVisible: false,
      projectId: '',
      selectParams: {
        clearable: true,
        disabled: false,
        placeholder: '全部项目'
      },
      treeParams: {
        data: [],
        filterable: true,
        checkStrictly: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      },
      mouseleaveTimer: null,
      drawerVisible: false,
      dataSource: {
        radioOptions: [
          { label: '特大', value: 60 },
          { label: '大', value: 44 },
          { label: '中', value: 30 },
          { label: '小', value: 18 }
        ],
        bmapTypeList: [
          { label: '标准地图', value: 'B_NORMAL_MAP' },
          { label: '地球模式', value: 'B_EARTH_MAP' },
          { label: '普通卫星地图', value: 'B_SATELLITE_MAP' }
        ]
      },
      formConfig: {
        labelWidth: '120px',
        span: 24,
        options: [
          {
            type: 'radioGroup',
            label: '地图类型:',
            prop: 'mapType',
            dataKey: 'bmapTypeList'
          }
        ]
      }
    };
  },
  computed: {
    ...mapState('app', ['theme', 'fullScreenFlag']),
    ...mapState('socket', ['deviceTree']),
    ...mapState('device', ['modeList', 'monitorMode', 'monitorConfig']),
    monitorModeRadio: {
      get() {
        return this.monitorMode;
      },
      set(v) {
        this.setMonitorMode(v);
      }
    },
    headerVisible() {
      if (!['list', 'alarm'].includes(this.monitorMode)) return true;
      return this.visible || this.popoverVisible || this.monitorConfig.fixedHeader;
    }
  },
  methods: {
    ...mapMutations('app', ['setTheme', 'setFullScreenFlag']),
    changeTheme() {
      const t = this.theme === 'dark' ? 'light' : 'dark';
      this.setTheme(t);
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    openSettingsPanel() {
      this.drawerVisible = true;
    },
    handleFixedHeader() {
      this.monitorConfig.fixedHeader = !this.monitorConfig.fixedHeader;
    },
    formatTooltip(v) {
      return `${v}px`;
    },
    handleMouseenter() {
      if (this.mouseleaveTimer) clearTimeout(this.mouseleaveTimer);
      this.show();
    },
    handleMouseleave() {
      if (this.mouseleaveTimer) clearTimeout(this.mouseleaveTimer);
      this.mouseleaveTimer = setTimeout(() => {
        this.hide();
      }, 600);
    },
    ...mapMutations('device', {
      setMonitorMode: Type.SET_MONITOR_MODE
    }),
    setTreeData(n) {
      this.treeParams.data = n;
    },
    treeFilter(v) {
      this.$refs.elTreeSelect.filterFun(v);
    },
    screenToggle() {
      this.isFullScreen = !this.isFullScreen;
      //   sessionStorage.setItem('fullScreenFlag', this.isFullScreen);
      this.setFullScreenFlag(this.isFullScreen);
      if (screenfull.isEnabled) {
        screenfull.toggle(this.getDroneEl());
        // screenfull.toggle();
      }
    },
    boxViewToggle() {
      this.$emit('toggleBoxView');
    }
  },
  mounted() {
    screenfull.onchange(() => {
      this.fullScreen = !this.fullScreen;
    });
  },
  watch: {
    deviceTree: {
      handler: 'setTreeData',
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
.drone-header {
  background-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9;
  height: 60px;
  user-select: none;

  .drone-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 100%;

    padding: 0 20px;
    box-sizing: border-box;
    transition: top 0.5s;
    &.hide {
      top: -100%;
    }
  }

  .right {
    display: flex;
    align-items: center;

    .icon {
      font-size: 16px;
      //   color: #0ef;
      color: var(--drone-list-base-font-color);
      justify-content: space-between;

      margin-right: 10px;
      cursor: pointer;
    }
  }

  .el-drawer__body {
    padding: 0 20px;

    .el-radio-group {
      gap: 0;
    }
  }
}
</style>
